import { Component, OnInit } from '@angular/core';
import { faEyeSlash, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-address-select-info',
    templateUrl: './address-select-info.component.html',
    styleUrls: ['./address-select-info.component.scss'],
})
export class AddressSelectInfoComponent implements OnInit {
    public allowToHide = false;
    public allowToDelete = false;
    public readonly faTrashAlt = faTrashAlt;
    public readonly faEyeSlash = faEyeSlash;

    public closeButtonTextBefore = '';
    public closeButtonTextAfter = '';
    public hideButtonTextBefore = '';
    public hideButtonTextAfter = '';

    public constructor(
        private translate: TranslateService,
        private modalInstance: BsModalRef,
    ) {}

    public ngOnInit(): void {
        const closeButtonText = this.translate.instant('TIMESHEET_ADDRESS_HELP_CLOSE_BUTTON_BODY_INFO');
        const hideButtonText = this.translate.instant('TIMESHEET_ADDRESS_HELP_HIDE_BUTTON_BODY_INFO');

        // Translations contain placeholders for both closeIcon and hideIcon
        // Using split to break the text into 2 blocks so that we can place the icon inbetween
        [this.closeButtonTextBefore, this.closeButtonTextAfter] = closeButtonText.split('{{closeIcon}}');
        [this.hideButtonTextBefore, this.hideButtonTextAfter] = hideButtonText.split('{{hideIcon}}');
    }

    public close(): void {
        this.modalInstance.hide();
    }
}
